export const environment = {
    production: true,
    api: 'https://feature41206.api.classichub.co.nz',
    buildVersion: '2026.10.29.3',
    uri: 'https://feature41206.classichub.co.nz',
    envName: 'feature41206',
    isTest: true,
};

